import React, {useEffect, useState} from 'react'
import './ticket.css'
import { DataGrid } from '@mui/x-data-grid';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllCases, submitCase, updateCase } from '../../api/caseApi';
import { handleAddCase } from '../../state/caseSlice';
import moment from 'moment';
import Loader from '../../components/loader/Loader'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { handleCloseModal, handleOpenModal } from '../../state/modalSlice';
import ActionCell from '../../components/actionCell/ActionCell'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);



const UpdateTicket = () => {
    const {user} = useSelector((state)=>state.user)
    const {cases} = useSelector((state)=>state.cases)
    const dispatch = useDispatch()
    const {ticketId} = useParams()

    const handleFormSubmit = async (data)=>{
        // setIsLoading(true)
        try {
            const formData = new FormData()
            const {title, issue, department, status, date } = data
            // formData.append('title', title)
            // formData.append('issue', issue)
            // formData.append('department', department)
            // formData.append('status', status)
            // formData.append('date', date)
            // formData.append('upload', selectFile)
            const res = await submitCase(user?.token, formData)
            if(res?.success){
                MySwal.fire({
                    icon: 'success',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 4000
                });
                // reset()
            }else{
                MySwal.fire({
                    icon: 'error',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 5000
                });
            }
            // setIsLoading(false)
        } catch (error) {
            // setIsLoading(false)
            console.log(error)
            MySwal.fire({
                icon: 'error',
                title: "There's an error processing your request, Try again",
                showConfirmButton: false,
                timer: 5000
            });
        }
    }

    const handleFetchCases = async ()=>{
        try {
            const res = await fetchAllCases(user?.token)
            dispatch(handleAddCase(res?.data))
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(()=>{
        handleFetchCases()
    },[])

    

    return (
        <section className='ticket'>

            {/* HEADING */}
            <div className="heading">
                <div className="heading__box">
                    <div className="heading-item">
                        <h3 className="heading-title">Update Resolution case | </h3>
                        <i class='bx bx-home heading__title-icon'></i>
                        <Link to="/" className="heading-text">
                            Home <i class='bx bx-chevron-right heading-icon'></i>
                        </Link>
                        <span className="heading-text">
                            Update Resolution case <i class='bx bx-chevron-right heading-icon'></i>
                        </span>
                    </div>
                    <p className="heading-text">
                        View and Update cases
                    </p>
                </div>
            </div>

            {/* TICKET CONTAINER */}
            <div className="ticket__container">
                
            </div>

        </section>
    )
}

export default UpdateTicket